import React from 'react';
import { Telephone, Envelope } from 'react-bootstrap-icons';
import SubSecretaria from '../Ejecutivo/SubSecretaria';
import '../../views/EjecutivoView.css';

const Secretaria = ({ item }) => {
  return (
    <>
      {item != null && (
        <div>
          <div className="ejecutivo-box secretaria">
            <div className="ejecutivo-linea"></div>
            <div className="ejecutivo-nombre">Secretaría de {item.secretaria.nombre}</div>
            <div className="ejecutivo-sub">{item.secretaria.secretarioNombre}</div>
            <div className="ejecutivo-sub">
              <Envelope />{' '}
              <a className="ejecutivo-link" href={'mailto:' + item.secretaria.secretarioEmail}>
                {item.secretaria.secretarioEmail}
              </a>
            </div>
            <div className="ejecutivo-sub">
              <Telephone /> Teléfono {item.secretaria.secretarioTelefono}
            </div>
          </div>
          {item.subSecretariaList !== null &&
            item.subSecretariaList.length > 0 &&
            item.subSecretariaList
              .filter((sub) => !sub.dependeIntendencia)
              .map((sub, idx) => <SubSecretaria key={idx} item={sub}></SubSecretaria>)}
        </div>
      )}
    </>
  );
};

export default React.memo(Secretaria);
